import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoIndaginePreliminare } from '../../../../common/models/tipologiche/tipo-indagine-preliminare';

export class FascicoloIndaginiPreliminari extends FascicoloFull {
  sezione: string;
  tipoIndaginePreliminare: TipoIndaginePreliminare;
  giudiceIndaginiPreliminari: string;
  giudiceUdienzaPreliminare: string;
  pubblicoMinistero: string;
  incidenteProbatorio: boolean;
  prove: string;
  sufficienzaProve: boolean;
  richiestaArchiviazione: boolean; // required se il campo SUFFICIENZA DELLE PROVE e' impostato a NO
  dataRichiestaArchiviazione: number;
  rimandoAlPM: boolean;
  richiestaRinvioAGiudizio: boolean;
  misureCautelari: boolean;
  misuraAdottata: string;
  richiestaOblazione: boolean;
  opposizioneArchiviazione: boolean;
  dataOpposizioneArchiviazione: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
